import { useQuery } from "@apollo/client";
import gql from "graphql-tag";
import {
  SolutionName as SolutionNameQuery,
  SolutionNameVariables
} from "./schema/SolutionName";

export const querySolutionName = gql`
  query SolutionName($solutionKey: Key!) {
    solutions {
      solution(solutionKey: $solutionKey) {
        key
        name
      }
    }
  }
`;

export const solutionNameFetchPolicy = "cache-first";

export default function useSolutionName(variables: SolutionNameVariables) {
  return useQuery<SolutionNameQuery, SolutionNameVariables>(querySolutionName, {
    variables,
    skip: !variables.solutionKey,
    fetchPolicy: solutionNameFetchPolicy
  });
}
